import { useEffect, useState } from "react";
import Pagination from "../components/Pagination";
import api from "../api/api";
import * as bootstrap from "bootstrap";
import Button from "../components/Button";
import InputField from "../components/InputField";
import SelectField from "../components/SelectField";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "../components/Table";
import usePagination from "../../src/utils/usePagination";
import SearchIcon from "@mui/icons-material/Search";

const UserMaster = () => {
  const [usermasters, setUsermasters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedUser, setSelectedUser] = useState(null);
  const [modalType, setModalType] = useState(null);

  //  SEARCH STATE
  const [search, setSearch] = useState("");

  //  FETCH USERS FROM API
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get("/users");
      // Map backend field names to frontend field names
      const usersData = response.data.users.map((user) => ({
        user_id: user.id,
        full_name: user.name,
        phone_number: user.phone,
        email: user.email,
        user_role: user.role_name,
        is_active: user.is_active,
        created_at: user.created_at,
      }));
      setUsermasters(usersData);
      setError(null);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  //  SEARCH FILTER
  const filteredBySearch = usermasters.filter((user) => {
    const term = search.toLowerCase();
    return (
      user.full_name?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term) ||
      user.phone_number?.toLowerCase().includes(term)
    );
  });

  //  PAGINATION ON FILTERED DATA
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredBySearch, 5);

  //  ADD NEW USER
  const handleAddUser = async () => {
    try {
      if (
        !selectedUser ||
        !selectedUser.full_name ||
        !selectedUser.email ||
        !selectedUser.phone_number ||
        !selectedUser.password
      ) {
        setError("Name, email, phone number, and password are required");
        return;
      }

      await api.post("/users", {
        name: selectedUser.full_name,
        phone: selectedUser.phone_number,
        email: selectedUser.email,
        role_name: selectedUser.user_role || "user",
        password: selectedUser.password,
      });

      // Refresh user list
      fetchUsers();
      handleCloseModal();
      setError(null);
    } catch (err) {
      console.error("Error adding user:", err);
      // Show error message from backend if available
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError("Failed to add user");
      }
    }
  };

  const handleSaveChanges = async () => {
    try {
      if (!selectedUser || !selectedUser.user_id) return;

      // Update user via API
      await api.put(`/users/${selectedUser.user_id}`, {
        name: selectedUser.full_name,
        phone: selectedUser.phone_number,
        email: selectedUser.email,
        role_name: selectedUser.user_role,
        is_active:
          selectedUser.is_active !== undefined ? selectedUser.is_active : true,
      });

      // Refresh user list
      fetchUsers();
      handleCloseModal();
    } catch (err) {
      console.error("Error updating User:", err);
      setError("Failed to update user");
    }
  };

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [usermasters, currentPage]);

  const handleOpenModal = (user, type) => {
    setError(null);
    // For add new user, create empty user object
    if (type === "add") {
      setSelectedUser({
        full_name: "",
        email: "",
        phone_number: "",
        user_role: "",
        is_active: true,
        password: "",
      });
    } else {
      setSelectedUser(user);
    }
    setModalType(type);
  };

  const handleCloseModal = () => {
    setSelectedUser(null);
    setModalType(null);
  };

  const handleConfirmDelete = async () => {
    try {
      if (!selectedUser || !selectedUser.user_id) return;

      // Delete user via API (soft delete)
      await api.delete(`/users/${selectedUser.user_id}`);

      // Refresh user list
      fetchUsers();
      handleCloseModal();
    } catch (err) {
      console.error("Failed to delete user", err);
      setError("Failed to delete user");
    }
  };

  const columns = [
    { label: "Name", accessor: "full_name" },
    { label: "Phone Number", accessor: "phone_number" },
    { label: "Email", accessor: "email" },
    { label: "Role", accessor: "user_role" },
    {
      label: "Action",
      render: (row) => (
        <>
          <EditIcon
            onClick={() => handleOpenModal(row, "edit")}
            style={{ cursor: "pointer", color: "#6b7280" }}
          />
          <DeleteIcon
            onClick={() => handleOpenModal(row, "delete")}
            style={{ cursor: "pointer", color: "#6b7280" }}
          />
        </>
      ),
    },
  ];

  // if (error) return <p className="text-danger">{error}</p>;

  return (
    <>
      {/*  SEARCH */}
      {/* <div className="mb-3 d-flex align-items-center gap-2">
        <div className="position-relative w-100 ">
        <input
          type="search"
          className="form-control ps-5"
          placeholder="Search users..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
  
        <SearchIcon
          style={{
            position: "absolute",
            left: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#6b7280",
            width: "16px",
            height: "16px",
          }}
        />
        </div>
 
         <Button
     size="md"
     btncls="w-16%"
     variant="primary"
    text="Add User"
    onClick={() =>
      handleOpenModal(
        {
          full_name: "",
          email: "",
          phone_number: "",
          user_role: "",
        },
        "add"
      )
    }
  />
  
      </div> */}
      <div className="mb-3 d-flex align-items-center gap-2">
        {/* Search Input */}
        <div className="position-relative flex-grow-1">
          <input
            type="search"
            className="form-control extrapdng"
            placeholder="Search users..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <SearchIcon
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#6b7280",
              width: "16px",
              height: "16px",
            }}
          />
        </div>

        {/* Add Button */}
        <Button
          size="sm"
          btncls="px-3"
          variant="primary"
          text="+Add User"
          onClick={() =>
            handleOpenModal(
              {
                full_name: "",
                email: "",
                phone_number: "",
                user_role: "",
              },
              "add",
            )
          }
        />
      </div>

      {/*  TABLE */}
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No users found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />

      {/*  MODAL */}
      {selectedUser && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {modalType === "edit"
                    ? "Edit User"
                    : modalType === "add"
                      ? "Add User"
                      : "Confirm Delete"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>

              <div className="modal-body">
                {modalType === "add" ? (
                  <form autoComplete="off">
                    {error && (
                      <div className="alert alert-danger py-2">{error}</div>
                    )}
                    <div className="mb-3">
                      <label className="form-label">Full Name :</label>
                      <InputField
                        value={selectedUser.full_name || ""}
                        type="text"
                        placeholder="Enter Full Name"
                        onChange={(e) =>
                          setSelectedUser({
                            ...selectedUser,
                            full_name: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email :</label>
                      <InputField
                        value={selectedUser.email || ""}
                        type="email"
                        placeholder="Enter Email"
                        autoComplete="off"
                        onChange={(e) =>
                          setSelectedUser({
                            ...selectedUser,
                            email: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone Number :</label>
                      <InputField
                        value={selectedUser.phone_number || ""}
                        type="text"
                        placeholder="Enter Phone Number"
                        // onChange={(e) => {
                        //   let val = e.target.value;
                        //   val = val.replace(/(?!^\+)\D/g, "");
                        //   setSelectedUser({
                        //     ...selectedUser,
                        //     phone_number: val,
                        //   });
                        // }}

                        onChange={(e) => {
  let val = e.target.value;

  val = val.replace(/(?!^\+)\D/g, "");

  // Limit to 10 digits
  val = val.slice(0, 10);

  setSelectedUser({
    ...selectedUser,
    phone_number: val,
  });
}}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Role :</label>
                      <SelectField
                        options={[
                          "sales",
                          "purchase",
                          "farmer",
                          "manager",
                          "admin",
                        ]}
                        value={selectedUser.user_role || ""}
                        onChange={(value) =>
                          setSelectedUser({ ...selectedUser, user_role: value })
                        }
                        placeholder="Select role"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Password :</label>
                      <InputField
                        value={selectedUser.password || ""}
                        type="password"
                        placeholder="Enter password"
                        autoComplete="new-password"
                        onChange={(e) =>
                          setSelectedUser({
                            ...selectedUser,
                            password: e.target.value,
                          })
                        }
                      />
                    </div>
                  </form>
                ) : modalType === "edit" ? (
                  <form>
                    <p className="mb-3">Full Name : {selectedUser.full_name}</p>
                    <p className="mb-3">Email : {selectedUser.email}</p>

                    <div className="mb-3">
                      <label className="form-label">Phone Number :</label>
                      <InputField
                        value={selectedUser.phone_number}
                        type="text"
                        onChange={(e) => {
                          let val = e.target.value;
                          val = val.replace(/(?!^\+)\D/g, "");
                           // Limit to 10 digits
  val = val.slice(0, 10);
                          setSelectedUser({
                            ...selectedUser,
                            phone_number: val,
                          });
                        }}
                      />
                    </div>
                  </form>
                ) : (
                  <div className="text-center">
                    <p>Are you sure you want to delete this user?</p>
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  style={{ background: "#6c757d" }}
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>

                {modalType === "delete" ? (
                  <Button
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                    text="Confirm"
                  />
                ) : modalType === "add" ? (
                  <Button
                    // className="btn btn-primary"
                    btncls="w-16%"
                    onClick={handleAddUser}
                    text="Add User"
                  />
                ) : (
                  <Button
                    // className="btn btn-primary"
                    btncls="w-16%"
                    onClick={handleSaveChanges}
                    text="Submit"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserMaster;
